import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
//import { slideInOutAnimation, flyInOutAnimation } from '../animations'
import { ClientService } from 'src/app/services/client.service';
import { ClientStyleService } from '../../services/client-style.service';
import { MessageService } from 'src/app/services/message.service';
import { DomSanitizer } from '@angular/platform-browser';
import { BaseComponent } from '../base/base.component';

@Component({
	selector: 'app-search',
	templateUrl: './search.component.html',
	styleUrls: ['./search.component.css']
})
export class SearchComponent extends BaseComponent implements OnInit {

	constructor(
		public router: Router, 
		private route: ActivatedRoute, 
		private _clientService: ClientService, 
		private _messageService: MessageService,
		private _clientStyleService: ClientStyleService,
		private formBuilder: FormBuilder,
		public sanitizer: DomSanitizer
		) {
		super(router, route, _messageService, _clientService, _clientStyleService);
		this._messageService.clearAppError();
	}

	searchForm: FormGroup;
	//private clientKey: string;
	private searchPlate: string;
	private searchCitation: string;
	clientStyle: string = '/assets/client-styles/555.css';

	get citationNumber(){
		return this.searchForm.get('citation_number');
	}
	get licensePlate(){
		return this.searchForm.get('license_plate');
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.searchForm = this.formBuilder.group({
			citation_number: [''],
			license_plate: ['']
		});

		this.route.paramMap.subscribe(params => {
			//this.clientKey = params.get('clientKey')

			let searchPlate = params.get('searchPlate')
			if (searchPlate !== undefined && searchPlate != null && searchPlate.trim() != '') {
				this.searchPlate = searchPlate.trim().toUpperCase();
				this.searchForm.controls['license_plate'].setValue(this.searchPlate);
			} else {
				this.searchPlate = '';
			}

			let searchCitation = params.get('searchCitation')
			if (searchCitation !== undefined && searchCitation != null && searchCitation.trim() != '') {
				this.searchCitation = searchCitation.trim().toUpperCase();
				this.searchForm.controls['citation_number'].setValue(this.searchCitation);
			} else {
				this.searchCitation = '';
			}
		});

		this.route.queryParamMap.subscribe(queryParams => {
			//this.clientKey = queryParams.get('clientKey')

			let searchPlate = queryParams.get('searchPlate')
			if (searchPlate !== undefined && searchPlate != null && searchPlate.trim() != '') {
				this.searchPlate = searchPlate.trim().toUpperCase();
			} else {
				this.searchPlate = '';
			}

			let searchCitation = queryParams.get('searchCitation')
			if (searchCitation !== undefined && searchCitation != null && searchCitation.trim() != '') {
				this.searchCitation = searchCitation.trim().toUpperCase();
			} else {
				this.searchCitation = '';
			}
		});
	}

	public search() {
		let searchForm = this.searchForm.value;
		this._messageService.clearAppError();


		if ((searchForm.citation_number === undefined || searchForm.citation_number == null || searchForm.citation_number.trim() == '') && (searchForm.license_plate === undefined || searchForm.license_plate == null || searchForm.license_plate.trim() == '')) {
			this._messageService.showAppAlert('Validation Fault!', 'You must provide either the vehicle license plate number or the printed citation number.')
		} else {
			this.router.navigate(['/pay-items', { searchPlate: searchForm.license_plate, searchCitation: searchForm.citation_number }]);
		}

		return false;
	}
}
